import { render, staticRenderFns } from "./AddressProperties.vue?vue&type=template&id=75e3ca80"
import script from "./AddressProperties.vue?vue&type=script&lang=js"
export * from "./AddressProperties.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports